import { BAOCustomElement } from '@bao/custom-element'
import { sectionRenderer } from '@bao/section-rendering'
import { debounce } from '@bao/utils'

class HeaderSearchDropdown extends BAOCustomElement() {
  constructor () {
    super()
    this._loading = false
    this._query = ''
  }

  connectedCallback () {
    super.connectedCallback()

    this.subscribeToEvents()
  }

  setupListeners () {
    super.setupListeners()

    // Input and form events
    this.debouncedHandleInput = debounce((event) => {
      this.handleInput(event)
    }, 200)

    this.listeners.add(
      this.els.input.element,
      'input',
      this.debouncedHandleInput,
    )

    this.listeners.add(
      this.els.form.element,
      'submit',
      this.handleSubmit.bind(this),
    )
  }

  subscribeToEvents () {
    document.addEventListener(
      'drawer-changed',
      this.handleDrawerChange.bind(this),
    )
  }

  handleInput (event) {
    this.query = event.target.value.trim()
  }

  handleSubmit (event) {
    if (this.loading) {
      event.preventDefault()
    }

    event.target.submit()
  }

  async renderSection () {
    try {
      this.loading = true

      const url = this.query
        ? this.url.replace('#query#', this.query)
        : window.location.href

      const response = await sectionRenderer.fetchSingle(this.sectionId, url)
      const newDOM = sectionRenderer.convertToDOM(response)
      const newBody = newDOM.querySelector(this.els.body.selector)

      this.els.body.element.innerHTML = newBody.innerHTML

      this.loading = false
    } catch (error) {
      console.error('Failed to load predictive search', error)
    }
  }

  handleDrawerChange () {
    if (window.drawers.activeDrawerKey === 'search') {
      setTimeout(() => {
        this.els.input.element.focus()
      }, 400)

      return
    }

    setTimeout(() => {
      if (!this.query) return
      this.els.input.element.value = ''
      this.query = ''
    }, 400)
  }

  get loading () {
    return this._loading
  }

  set loading (value) {
    this._loading = value
    this.setAttribute('aria-busy', value)
  }

  get query () {
    return this._query
  }

  set query (value) {
    this._query = value
    this.renderSection()
  }

  get sectionId () {
    return this.dataset.sectionId
  }

  get url () {
    return this.dataset.url
  }
}

if (!customElements.get('header-search-dropdown')) {
  customElements.define('header-search-dropdown', HeaderSearchDropdown)
}
